import {
  UI_COLOR_AUDIT_CHIP_BG,
  UI_COLOR_AUDIT_LINK,
  UI_COLOR_AUDIT_PANEL_BG,
  UI_COLOR_AUDIT_STRIKE,
  UI_COLOR_AUDIT_STRIKE_CHIP,
  UI_COLOR_AUDIT_SYSTEM_BG,
  UI_COLOR_DANGER,
  UI_COLOR_DANGER_SOFT,
  UI_COLOR_PRIMARY_LIGHT_BG,
  UI_COLOR_PRIMARY_PRESSED,
  UI_COLOR_RBAC_TABLE_HEADER_BG,
  UI_COLOR_SECONDARY,
  UI_COLOR_SUCCESS,
  UI_COLOR_SUCCESS_SOFT,
  UI_COLOR_SURFACE_100,
  UI_COLOR_SKELETON_BAR,
  UI_COLOR_TEXT_AUDIT_FAINT,
  UI_COLOR_TEXT_AUDIT_MUTED,
  UI_COLOR_TEXT_AUDIT_PRIMARY,
  UI_COLOR_TEXT_AUDIT_SECONDARY,
  UI_COLOR_TEXT_ICON
} from '../../../constants/uiColors'
import { RBAC_USER_DETAIL_TEXTS } from '../../pages/shared/rbacUserDetailConstants'

export const AUDIT_CHIP_VARIANTS = {
  green: {
    backgroundColor: UI_COLOR_SUCCESS_SOFT,
    color: UI_COLOR_SUCCESS
  },
  blue: {
    backgroundColor: UI_COLOR_RBAC_TABLE_HEADER_BG,
    color: UI_COLOR_SECONDARY
  },
  orange: {
    backgroundColor: UI_COLOR_PRIMARY_LIGHT_BG,
    color: UI_COLOR_PRIMARY_PRESSED
  },
  red: {
    backgroundColor: UI_COLOR_DANGER_SOFT,
    color: UI_COLOR_DANGER
  }
}

export const USER_ACTION_CHIPS = {
  create: { label: 'Usuario creado', variant: 'green' },
  update: { label: 'Usuario editado', variant: 'blue' },
  assign_roles: { label: 'Rol reasignado', variant: 'orange' },
  create_app_user_relation: {
    label: RBAC_USER_DETAIL_TEXTS.appUserRelationCreated,
    variant: 'green'
  },
  update_app_user_relation: {
    label: RBAC_USER_DETAIL_TEXTS.appUserRelationUpdated,
    variant: 'blue'
  },
  activate: { label: 'Usuario activado', variant: 'green' },
  deactivate: { label: 'Usuario inactivado', variant: 'red' },
  account_activated: { label: 'Cuenta activada', variant: 'green' },
  invitation_sent: { label: 'Invitación enviada', variant: 'blue' },
  resend_invitation: { label: 'Invitación enviada', variant: 'blue' },
  invitation_failed: { label: 'Error de invitación', variant: 'red' },
  sessions_revoked: { label: 'Sesiones revocadas', variant: 'orange' }
}

export const ROLE_ACTION_CHIPS = {
  create: { label: 'Rol creado', variant: 'green' },
  update: { label: 'Rol editado', variant: 'blue' },
  update_permissions: { label: 'Permisos modificados', variant: 'orange' },
  activate: { label: 'Rol activado', variant: 'green' },
  deactivate: { label: 'Rol inactivado', variant: 'red' }
}

export const USER_PROFILE_FIELD_LABELS = {
  name: 'Nombre',
  phone: 'Teléfono',
  email: 'Correo'
}

export const ROLE_PROFILE_FIELD_LABELS = {
  name: 'Nombre',
  description: 'Descripción'
}

export const auditMutedTextSx = {
  fontSize: 13,
  color: UI_COLOR_TEXT_AUDIT_MUTED,
  lineHeight: 1.5
}

export const auditSystemTextSx = {
  fontSize: 13,
  fontStyle: 'italic',
  color: UI_COLOR_TEXT_AUDIT_MUTED,
  lineHeight: 1.5
}

export const auditDetailLinkSx = {
  color: UI_COLOR_AUDIT_LINK,
  textDecoration: 'underline',
  textUnderlineOffset: '2px',
  fontSize: 13,
  fontWeight: 500,
  cursor: 'pointer',
  border: 'none',
  background: 'none',
  padding: 0,
  fontFamily: 'inherit'
}

export const auditExpandedPanelSx = {
  mt: 1.25,
  px: '14px',
  py: '12px',
  backgroundColor: UI_COLOR_AUDIT_PANEL_BG,
  borderRadius: '6px'
}

export const auditExpandedItemSx = {
  fontSize: 13,
  py: 0.5,
  lineHeight: 1.5,
  '& + &': {
    borderTop: `1px solid ${UI_COLOR_SURFACE_100}`,
    mt: 0.5,
    pt: 0.75
  }
}

export const auditChangeRowSx = {
  display: 'block',
  lineHeight: 1.5,
  '& + &': {
    mt: 0.5
  }
}

export const auditPermissionRowSx = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 1,
  lineHeight: 1.6
}

export const auditPermissionLabelSx = {
  fontSize: 14,
  color: UI_COLOR_TEXT_AUDIT_MUTED,
  flexShrink: 0
}

export const auditFieldLabelSx = {
  fontSize: 13,
  color: UI_COLOR_TEXT_AUDIT_MUTED
}

export const auditPrimaryTextSx = {
  fontSize: 13,
  color: UI_COLOR_TEXT_AUDIT_PRIMARY,
  fontWeight: 500
}

export const auditStrikeTextSx = {
  fontSize: 13,
  color: UI_COLOR_TEXT_AUDIT_SECONDARY,
  textDecoration: 'line-through',
  textDecorationColor: UI_COLOR_AUDIT_STRIKE
}

export const auditArrowTextSx = {
  fontSize: 13,
  color: UI_COLOR_TEXT_AUDIT_FAINT
}

export const auditSummaryTextSx = {
  fontSize: 14,
  color: UI_COLOR_TEXT_AUDIT_PRIMARY
}

export const auditActorPrimarySx = {
  fontSize: 14,
  fontWeight: 500,
  color: UI_COLOR_TEXT_AUDIT_PRIMARY,
  lineHeight: 1.4
}

export const auditActorSecondarySx = {
  fontSize: 12,
  color: UI_COLOR_TEXT_AUDIT_SECONDARY,
  lineHeight: 1.4,
  mt: 0.25
}

export const auditDatePrimarySx = {
  fontSize: 14,
  fontWeight: 500,
  color: UI_COLOR_TEXT_AUDIT_PRIMARY,
  lineHeight: 1.4
}

export const auditDateSecondarySx = {
  fontSize: 13,
  color: UI_COLOR_TEXT_AUDIT_MUTED,
  lineHeight: 1.4,
  mt: 0.25
}

export const auditSystemBadgeSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  px: '10px',
  py: '3px',
  backgroundColor: UI_COLOR_AUDIT_SYSTEM_BG,
  color: UI_COLOR_TEXT_ICON,
  fontSize: 12,
  fontWeight: 500,
  borderRadius: '12px'
}

export const auditSubtitleSx = {
  fontSize: 16,
  color: UI_COLOR_TEXT_AUDIT_MUTED,
  m: 0,
  lineHeight: 1.3
}

export const auditChipSx = {
  minWidth: 0,
  height: 24,
  padding: '0 10px 0 7px',
  fontSize: '11px',
  fontWeight: 600,
  textTransform: 'none',
  backgroundColor: UI_COLOR_AUDIT_CHIP_BG,
  color: UI_COLOR_TEXT_ICON
}

export const auditStrikethroughChipSx = {
  textDecoration: 'line-through',
  textDecorationColor: UI_COLOR_AUDIT_STRIKE_CHIP,
  opacity: 0.75
}

export const auditActionChipBaseSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  px: '12px',
  py: '5px',
  borderRadius: '16px',
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: '0.3px',
  whiteSpace: 'nowrap',
  lineHeight: 1.2
}

export const skeletonBarSx = {
  bgcolor: UI_COLOR_SKELETON_BAR,
  transform: 'none'
}
